import { render, staticRenderFns } from "./select-type.vue?vue&type=template&id=4d0367a8&scoped=true&"
import script from "./select-type.vue?vue&type=script&lang=js&"
export * from "./select-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0367a8",
  null
  
)

export default component.exports